"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
import { ApiDropType } from "@/generated/models/ApiDropType";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { useRouter, usePathname, useSearchParams } from "next/navigation";
interface WaveDropMobileMenuOpenProps {
  readonly drop: ExtendedDrop;
  readonly onOpenChange: () => void;
}
const WaveDropMobileMenuOpen: React.FC<WaveDropMobileMenuOpenProps> = t0 => {
  const $ = _c(10);
  const {
    drop,
    onOpenChange
  } = t0;
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const canBeOpened = drop.drop_type !== ApiDropType.Chat;
  if (!canBeOpened) {
    return null;
  }
  let t1;
  if ($[0] !== drop.id || $[1] !== onOpenChange || $[2] !== pathname || $[3] !== router || $[4] !== searchParams) {
    t1 = () => {
      const params = new URLSearchParams(searchParams.toString());
      params.set("drop", drop.id);
      router.push(`${pathname}?${params.toString()}`);
      onOpenChange();
    };
    $[0] = drop.id;
    $[1] = onOpenChange;
    $[2] = pathname;
    $[3] = router;
    $[4] = searchParams;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const onDropClick = t1;
  let t2;
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true" className="tw-flex-shrink-0 tw-w-5 tw-h-5 tw-text-iron-300" xmlns="http://www.w3.org/2000/svg"><path d="M21 9L21 3M21 3H15M21 3L13 11M10 5H7.8C6.11984 5 5.27976 5 4.63803 5.32698C4.07354 5.6146 3.6146 6.07354 3.32698 6.63803C3 7.27976 3 8.11984 3 9.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21H14.2C15.8802 21 16.7202 21 17.362 20.673C17.9265 20.3854 18.3854 19.9265 18.673 19.362C19 18.7202 19 17.8802 19 16.2V14" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" /></svg>;
    t3 = <span className="tw-text-iron-300 tw-font-semibold tw-text-base">Open drop</span>;
    $[6] = t2;
    $[7] = t3;
  } else {
    t2 = $[6];
    t3 = $[7];
  }
  let t4;
  if ($[8] !== onDropClick) {
    t4 = <button onClick={onDropClick} className="tw-border-0 tw-flex tw-items-center tw-gap-x-4 tw-p-4 tw-bg-iron-950 tw-rounded-xl active:tw-bg-iron-800 tw-transition-colors tw-duration-200 tw-select-none">{t2}{t3}</button>;
    $[8] = onDropClick;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};
export default WaveDropMobileMenuOpen;